import Bell from "../../assets/icons/bell.svg";
import PropTypes from "prop-types";

const ApplicationModal = ({ modal, onClickModalButton }) => {
  return (
    <div
      id="application_modal"
      className="h-screen w-screen bg-black bg-opacity-90 fixed z-50 flex flex-col justify-center items-center"
    >
      <div className="text-center rounded-lg bg-white">
        <div className="px-4">
          <div className="flex flex-col items-center py-5">
            <div className="p-4 sys_bg_white2 rounded-full">
              <img className="w-5" src={Bell} alt="" />
            </div>
            <h1 className="font-semibold mt-3 mb-2 sys_black text-xs">
              {modal.title}
            </h1>
            <p className="sys_gray text-sm" style={{ width: "312px" }}>
              {modal.caption}
            </p>
          </div>
        </div>
        <div className="sys_bg_white2 rounded-b-xl py-3 px-4">
          <button
            onClick={onClickModalButton}
            className="rounded-lg py-3 sys_bg_primary text-white w-full hover: font-semibold"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

ApplicationModal.propTypes = {
  modal: PropTypes.object,
  onClickModalButton: PropTypes.func,
}

export default ApplicationModal;
